<template>
  <div>
    <el-form-item label="Propriétés" >
      <div v-if="!myDimension || !myDimension.length || !myDimension[0].value.properties.length" >
        Veuiller sélectionner une dimension disposant de propriétés
      </div>
      <el-select
        v-else
        v-model="selectedProperties"
        value-key="uniqueName"
        :multiple="true"
        @change="handleChange" >
        <el-option
          v-for="property in properties"
          :key="property.uniqueName"
          :label="property.name"
          :value="property" />
      </el-select>
    </el-form-item>
  </div>
</template>

<script>
export default {
  props: {
    myDimension: {
      required: false
    },
    value: {
      type: String,
    }
  },
  data () {
    return {
      selectedProperties: []
    }
  },
  watch:
  {
    value: {
      handler (value) {
        try {
          const data = JSON.parse(value)
          if (typeof data === 'object') {
            this
              .selectedProperties
              .splice(0, this.selectedProperties.length, ...(data.properties || []))
          }
        } catch (error) {
          this.setDefaultValues()
        }
      },
      immediate: true
    },
    myDimension () {
      this.selectedProperties.splice(
        0,
        this.selectedProperties.length,
        ...this.selectedProperties.filter(property => {
          return this.myDimension[0].value.properties.findIndex(p => {
            return p.uniqueName === property.uniqueName
          }) > -1
        })
      )
      this.handleChange()
    }
  },
  computed: {
    properties () {
      if (!this.myDimension || !this.myDimension.length) {
        return []
      }
      return this.myDimension[0].value.properties
    }
  },
  methods: {
    setDefaultValues () {
      this.selectedProperties.splice(0, this.selectedProperties.length)
    },
    handleChange () {
      const data = {
        properties: this.selectedProperties
      }
      this.$emit('input', JSON.stringify(data))
      this.$emit('change', data)
    }
  }
}
</script>



// WEBPACK FOOTER //
// node_modules/macarons-graphs-front/src/config/DataTable.vue